// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2hh_6","obliqueLineWrap":"membershipbadge_obliqueLineWrap__KFAXN","obliqueLine":"membershipbadge_obliqueLine__hsNht"};